<div class="common-actions-menu">
  <button
    #ellipsisButton
    class="btn btn--icon ellipsis-button"
    (click)="toggleMenu($event)"
    type="button"
    aria-label="More actions">
    <svg class="btn__icon ellipsis-icon" width="16" height="16">
      <use xlink:href="#ellipsis"></use>
    </svg>

    @if (totalCount) {
      <span class="btn__text">
        {{ totalCount }}
      </span>
    }
  </button>

  <div class="actions-menu" [class.open]="isMenuOpen">
    <div class="actions-menu__content">
      @for (item of items; track item) {
        <button
          type="button"
          class="actions-menu__item"
          [class.disabled]="item.disabled"
          [class.locked]="item.locked"
          (click)="onAction(item, $event)">
          <svg class="icon" [attr.width]="iconSize" [attr.height]="iconSize">
            <use [attr.xlink:href]="'#' + item.iconRef"></use>
          </svg>
          @if (item.label) {
            <span class="label">
              {{ item.label }}
            </span>
          }
          @if (item.locked) {
            <svg class="lock-icon" width="11" height="11">
              <use xlink:href="#locked"></use>
            </svg>
          }
        </button>
      }
    </div>
  </div>
</div>
